import React from "react";
import { Form } from "react-bootstrap";
import { BsBuilding, BsXCircle } from "react-icons/bs";
import { SguUnitsSideMenu, SguUnitMenuItem } from "../../../components/SguUnitsMenu";
import DashMedidasButton from "../../DashMedidas/components/DashMedidasButton/DashMedidasButton";

const ListaEmpresas = ({
  user,
  companies,
  equipmentList,
  setEquipmentList,
  headerRight,
  onSearch,
  searchValue,
  listRef,
}) => {
  const textoLimitado = (texto, limite = 25) => {
    return texto.length <= limite ? texto : texto.slice(0, limite) + "...";
  };

  const selectedUnitsCount = React.useMemo(() => {
    const ids = new Set(
      (equipmentList || [])
        .map((item) => String(item.companyId || "").trim())
        .filter(Boolean)
    );
    return ids.size;
  }, [equipmentList]);

  const handleClearSelection = () => {
    setEquipmentList([]);
  };

  const handleCheckboxChange = (event, company) => {
    const { _id, equipments } = company;

    if (event.target.checked) {
      const newEquipmentMappings = (equipments || []).map((equipment) => ({
        companyId: _id,
        equipment: String(equipment).trim(),
      }));

      setEquipmentList((prevEquipments) => {
        const withoutCompany = prevEquipments.filter(
          (mapping) => mapping.companyId !== _id
        );
        return [...withoutCompany, ...newEquipmentMappings];
      });
    } else {
      setEquipmentList((prevEquipments) =>
        prevEquipments.filter((mapping) => mapping.companyId !== _id)
      );
    }
  };

  const isCompanyChecked = (company) => {
    const { _id, equipments } = company;

    if (!equipments || equipments.length === 0) {
      return false;
    }

    return equipments.every((equipment) => {
      const serial = String(equipment || "").trim();
      return equipmentList.some(
        (mapping) =>
          mapping.companyId === _id &&
          String(mapping.equipment || "").trim() === serial
      );
    });
  };

  return (
    <SguUnitsSideMenu
      icon={BsBuilding}
      subtitle="Seleção"
      title="Unidades"
      headerRight={headerRight}
      sectionId="relatorios-unidades"
      searchValue={searchValue}
      onSearch={onSearch}
      listRef={listRef}
      emptyText="Nenhuma unidade encontrada"
      toolbarExtra={
        selectedUnitsCount > 0 ? (
          <DashMedidasButton
            className="w-100 relatorios-clear-units-btn"
            variant="outline-danger"
            onClick={handleClearSelection}
            title="Desmarcar todas as unidades selecionadas"
          >
            <BsXCircle /> Desmarcar selecionadas
          </DashMedidasButton>
        ) : null
      }
    >
      {(companies || []).map((company) => {
        const checked = isCompanyChecked(company);
        const hasEquipments = company.equipments && company.equipments.length > 0;

        return (
          <SguUnitMenuItem
            key={company._id}
            variant="div"
            row
            active={checked}
            disabled={!hasEquipments}
            title={
              user?.hideSensitiveInfo
                ? "*****"
                : textoLimitado(company.name, 30)
            }
            meta={
              hasEquipments ? (
                <span className="sgu-unit-item__meta">
                  Equipamentos: {company.equipments.length}
                </span>
              ) : (
                <span className="sgu-unit-item__meta sgu-unit-item__meta--warn">
                  Sem equipamentos
                </span>
              )
            }
            trailing={
              hasEquipments ? (
                <Form.Check type="checkbox" className="sgu-unit-item__check">
                  <Form.Check.Input
                    type="checkbox"
                    onChange={(event) => handleCheckboxChange(event, company)}
                    checked={checked}
                    isValid
                  />
                </Form.Check>
              ) : null
            }
          />
        );
      })}
    </SguUnitsSideMenu>
  );
};

export default ListaEmpresas;
